var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    group = _require$doc$builders.group,
    indent = _require$doc$builders.indent,
    softline = _require$doc$builders.softline;

var isBeginnigOfChain = function isBeginnigOfChain(path) {
  var parentNodeType = path.getParentNode().type;
  if (parentNodeType === 'MemberAccess') return false;

  if (parentNodeType === 'FunctionCall') {
    var grandParentNodeType = path.getParentNode(1).type;
    return grandParentNodeType !== 'MemberAccess';
  }

  return true;
};

var MemberAccess = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    var doc = concat([path.call(_print, 'expression'), indent(concat([softline, '.', node.memberName]))]);
    return isBeginnigOfChain(path) ? group(doc) : doc;
  }
};
module.exports = MemberAccess;